import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null); // Firebase user
  const [userProfile, setUserProfile] = useState(null); // Firestore profile (role, status)
  const [loading, setLoading] = useState(true);

  // Firebase auth state listener
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      setCurrentUser(firebaseUser);

      if (firebaseUser) {
        try {
          // Backend থেকে profile আনো (role, status etc)
          const token = await firebaseUser.getIdToken();
          const res = await axios.get('/api/auth/me', {
            headers: { Authorization: `Bearer ${token}` }
          });
          setUserProfile(res.data.data);
        } catch {
          setUserProfile(null);
        }
      } else {
        setUserProfile(null);
      }

      setLoading(false);
    });

    return unsub;
  }, []);

  // Token getter — API calls এ use করবে
  const getToken = async () => {
    if (!currentUser) return null;
    return await currentUser.getIdToken();
  };

  // Login
  const login = async (email, password) => {
    const cred = await signInWithEmailAndPassword(auth, email, password);
    const token = await cred.user.getIdToken();

    // Backend এ login hit করো (last login update)
    const res = await axios.post('/api/auth/login', {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setUserProfile(res.data.data);
    return res.data.data;
  };

  // Register
  const register = async (name, email, password, phone = '') => {
    // Backend এ register (Firebase Auth + Firestore)
    const res = await axios.post('/api/auth/register', { name, email, password, phone });

    // তারপর login করো
    await signInWithEmailAndPassword(auth, email, password);
    setUserProfile(res.data.data);
    return res.data.data;
  };

  // Logout
  const logout = async () => {
    await signOut(auth);
    setUserProfile(null);
  };

  const value = {
    currentUser,
    userProfile,
    loading,
    getToken,
    login,
    register,
    logout,
    isAdmin:  userProfile?.role === 'admin',
    isClient: userProfile?.role === 'client',
    isBlocked: userProfile?.status === 'blocked',
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
